import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import selectors from '@/ui/flux/selectors';
import useBuyAvailability from './use-buy-availability.js';

export type IsBuySupportedByAssetFn = (assetName: string) => {
  value: boolean;
  loading: boolean;
};

function useIsBuySupportedByAssetFn(): IsBuySupportedByAssetFn {
  const { value: isAvailable, loading } = useBuyAvailability();

  const isBuySupportedByAsset = useSelector<unknown, (name: string) => boolean>(
    selectors.fiatRamp.isBuySupportedByAsset,
  );

  return useCallback(
    (assetName: string) => ({
      value: isAvailable && isBuySupportedByAsset(assetName),
      loading,
    }),
    [isAvailable, loading, isBuySupportedByAsset],
  );
}

export default useIsBuySupportedByAssetFn;
